module.exports = __webpack_public_path__ + "img/4.bf3e8f59.jpg";